module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--gift-8c8d58291099dc792911af163e6470e7.png";